import { render, staticRenderFns } from "./OrderPaymentPopup.vue?vue&type=template&id=d65ab52e"
import script from "./OrderPaymentPopup.vue?vue&type=script&lang=js"
export * from "./OrderPaymentPopup.vue?vue&type=script&lang=js"
import style0 from "./OrderPaymentPopup.vue?vue&type=style&index=0&id=d65ab52e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports